import { PageTitle } from '../../layout/core'
import ListColumns from './ListColumns'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import FormBuilder from './formBuilder/FormBuilder'
import AskPdf from './AskPdf'
import BusinessProcessAutomation from './BusinessProcessAutomation'
import OpticalCharacterRecognition from './OpticalCharacterRecognition'
import DocumentManagementSystem from './DocumentManagementSystem'
import InstantMaturityAssessments from './InstantMaturityAssessments'
import ResumeParser from './ResumeParser'
import CreateNewForm from './formBuilder/CreateNewForm'
import ShareForm from './formBuilder/ShareForm'
import PrefillRecipientsPage from './formBuilder/PrefillRecipientsPage'
import UserContext from '../../context/UserContext'
import { useContext, useEffect, useState } from 'react'
import axios from 'axios'
import WorkflowAutomation from './workflow'

const ProcessAutomation = () => {
  const { currentUser } = useContext(UserContext)
  const location = useLocation()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [hasOpenAIKeyProvided, setHasOpenAIKeyProvided] = useState<boolean>(true)

  const fetchUserIbotInfo = async () => {
    setIsLoading(true)
    try {
      const params = {
        bg_id: currentUser.id
      }

      const response = await axios.get(
        `${process.env.REACT_APP_RESUME_PARSER_URL}/new_ibot_app/all_bots?bg_id=${currentUser.id}`,
        { params }
      )

      if (response && response.data.hasOpenAIKey) {
        setHasOpenAIKeyProvided(true)
        setIsLoading(false)
      }
    } catch (error) {
      // Handle errors
      console.error('Error making the GET request:', error)
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchUserIbotInfo()
  }, [])

  const isFormBuilder = location.pathname.endsWith('/form-builder')
  const isPrefillRecipients = location.pathname.includes('/prefill-recipients')
  const useFullWidthLayout = isFormBuilder || isPrefillRecipients

  const contentColumnClass = isPrefillRecipients
    ? 'col-12 d-flex flex-column px-3 px-md-4 pb-4'
    : `${useFullWidthLayout ? '' : 'card'} col ms-xl-6 d-flex flex-column h-800px scroll-y`

  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {isPrefillRecipients ? 'Recipient Forms' : 'Process Automation'}
      </PageTitle>
      <section className='row g-0'>
        {!isPrefillRecipients && (
          <div className='card px-2 col-2 h-800px border border-secondary rounded'>
            <ListColumns />
          </div>
        )}

        <div className={contentColumnClass}>
          <Routes>
            <Route path='form-builder' element={<FormBuilder />} />
            <Route
              path='ask-pdf'
              element={<AskPdf hasOpenAIKeyProvided={hasOpenAIKeyProvided} />}
            />
            <Route path='business-process-automation' element={<BusinessProcessAutomation />} />
            <Route path='optical-character-recognition' element={<OpticalCharacterRecognition />} />
            <Route path='document-management-system' element={<DocumentManagementSystem />} />
            <Route path='resume-parser' element={<ResumeParser />} />
            <Route path='form-builder/create-new-form' element={<CreateNewForm />} />
            <Route
              path='form-builder/share-form/:uuid/prefill-recipients'
              element={<PrefillRecipientsPage />}
            />
            <Route path='form-builder/share-form/:uuid' element={<ShareForm />} />
            <Route path='workflow-automation' element={<WorkflowAutomation />} />
            <Route path='instant-maturity-assessments' element={<InstantMaturityAssessments />} />
            <Route index element={<Navigate to='form-builder' />} />
          </Routes>
        </div>
      </section>
    </>
  )
}
export default ProcessAutomation
